import { Task } from 'mixs/orders/planner_base';

class TasksSchedulesText extends Task {
  public firstScheduleText: string;
  public lastScheduleText: string;
  init(){
    super.init();
    let schedule_ids = this.opts.schedules
    let firstSchedule = this.getScheduleData(this.opts.schedules[0])
    let lastSchedule = this.getScheduleData(schedule_ids[schedule_ids.length - 1])
    this.firstScheduleText = firstSchedule.start_time_text;
    this.lastScheduleText  = lastSchedule.end_time_text;
  }
}

riot.mixin('tasks.schedules-text', TasksSchedulesText as riot.TagMixin)
